import {FormatterBasic} from "./Core/FormatterBasic";

export class DateFormatter extends FormatterBasic {
    Format(): string {
        return this.GetValue('Value');
    }

}